<template>
  <UIButton
    rounded="full"
    class="font-bold"
  >
    <template
      v-if="$slots.prepend"
      #prepend
    >
      <slot name="prepend" />
    </template>
    <slot />
    <template
      v-if="$slots.append"
      #append
    >
      <slot name="append" />
    </template>
  </UIButton>
</template>
